import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import TextField from "@mui/material/TextField";
import Switch from "@mui/material/Switch";
import FormControlLabel from "@mui/material/FormControlLabel";
import MenuItem from "@mui/material/MenuItem";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Box } from "@mui/material";
import Loader from "components/Loader";

import Select from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Chip from "@mui/material/Chip";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";

// Data
import authorsTableData from "./table-data";

// Redux and API
import { useDispatch, useSelector } from "react-redux";
import { setLoading } from "../../../redux/Reducers/GlobalReducer/globalSlice";
import { useSnackbarContext } from "components/SnackBarContext";
import { API_FAIL_MESSAGE, SUCCESS } from "constants/apiConstants";

import { API_ENDPOINTS, BASE_IMAGE_URL } from "constants/apiConstants";

import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import api from "services/api";
import { compressToUnder5MB } from "./utlis";


function Property() {
  const [tableData, setTableData] = useState([]);
  const [open, setOpen] = useState(false);
  const [newTitle, setNewTitle] = useState("");
  const [newDescription, setNewDescription] = useState("");
  const [featuresDesc, setFeaturesDesc] = useState("");
  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    data: null,
  });
  const [price, setPrice] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [stateVal, setStateVal] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [propertyType, setPropertyType] = useState("apartment");
  const [status, setStatus] = useState("available");

  const [leaseTerm, setLeaseTerm] = useState("");
  const [bedrooms, setBedrooms] = useState(""); // instead of 0
  const [bathrooms, setBathrooms] = useState("");
  const [areaSqft, setAreaSqft] = useState("");
  const [availableFrom, setAvailableFrom] = useState(
    new Date().toISOString().slice(0, 10)
  );
  const [isActive, setIsActive] = useState(true);
  const [editingItem, setEditingItem] = useState(null);

  const [buildstyleId, setBuildstyleId] = useState("");
  const [communityId, setCommunityId] = useState("");
  const [buildstyleIds, setBuildstyleIds] = useState([]); // ✅ array, not 0
  const [communityIds, setCommunityIds] = useState([]);
  const [aminityIds, setAminityIds] = useState([]);
  const [featuresIds, setFeatureIds] = useState([]);

  const [buildStyles, setBuildStyles] = useState([]);
  console.log("buildStyles", buildStyles);
  const [communities, setCommunities] = useState([]);
  console.log("communities", communities);
  const [aminities, setAminities] = useState([]);
  console.log("aminities", aminities);
  const [features, setFeatures] = useState([]);
  const [states, setSates] = useState([]);
  const [cities, setCities] = useState([]);

  const [gardenFloor, setGardenFloor] = useState("");
  const [mainFloor, setMainFloor] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [parking, setParking] = useState("");

  
  const [isLoading, setIsLoading] = useState(false);
  

  const auth = useSelector((state) => state.auth);
  const { IsLoginData } = auth;
  const tableName = "Property";
  const [thumbnailImage, setThumbnailImage] = useState(null); // preview + file
  const [thumbnailUrl, setThumbnailUrl] = useState(""); // uploaded URL for API

  const [propertyImages, setPropertyImages] = useState([]); // preview + file list
  const [propertyImageUrls, setPropertyImageUrls] = useState([]); // uploaded URLs for API

  const [floorImages, setFloorImages] = useState([]);
  const [floorImageUrls, setFloorImageUrls] = useState([]);

  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();
  const { showErrorSnackbar, showSuccessSnackbar } = useSnackbarContext();

  // useEffect(() => {
  //   return () => {
  //     propertyImages.forEach((img) => URL.revokeObjectURL(img.url));
  //   };
  // }, [propertyImages]);
  useEffect(() => {
    getTableData();
    getDropdownData();
  }, []);
  const getTableData = async () => {
    try {
      dispatch(setLoading(true));
      const response = await api.get(API_ENDPOINTS.GET_PROPERTIES);
      console.log(`GET ${tableName}`, response);
      dispatch(setLoading(false));
      const { status, data, message } = response.data;
      if (status === SUCCESS) {
        setTableData(data);
      } else {
        showErrorSnackbar(message);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const getDropdownData = async () => {
    try {
      dispatch(setLoading(true));

      const [
        communitiesRes,
        featuresRes,
        amenitiesRes,
        buildstylesRes,
        StatesRes,
      ] = await Promise.all([
        api.get(API_ENDPOINTS.GET_COMMUNITIES),
        api.get(API_ENDPOINTS.GET_FEATURES),
        api.get(API_ENDPOINTS.GET_AMINITIES),
        api.get(API_ENDPOINTS.GET_BUILDSTYLES),
        api.get(API_ENDPOINTS.GET_STATES),
        // api.get(API_ENDPOINTS.GET_CITY),
      ]);

      // console.log("CityRes", CityRes);

      dispatch(setLoading(false));

      const statesRes = transDropdownData(
        "state_id",
        "state",
        StatesRes?.data?.data || []
      );
      setSates(statesRes);

      const communities = transDropdownData(
        "community_id",
        "communityname",
        communitiesRes?.data?.data || []
      );
      setCommunities(communities);
      const features = transDropdownData(
        "feature_id",
        "feature_name",
        featuresRes?.data?.data || []
      );
      setFeatures(features);
      const amenities = transDropdownData(
        "amenity_id",
        "amenity_name",
        amenitiesRes?.data?.data || []
      );
      setAminities(amenities);
      const buildstyles = transDropdownData(
        "buildstyle_id",
        "stylename",
        buildstylesRes?.data?.data || []
      );

      setBuildStyles(buildstyles);
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };

  const transDropdownData = (id, name, communities = []) => {
    return communities.map((item) => ({
      id: item[id],
      name: item[name],
    }));
  };
  const handlePropertyImagesChange = (e) => {
    const files = Array.from(e.target.files);

    const previews = files.map((file) => ({
      file,
      url: URL.createObjectURL(file),
    }));

    setPropertyImages((prev) => [...prev, ...previews]);

    files.forEach((file) => UploadImage(file, "property"));
  };
  const handleDeleteExistingPropertyImage = (indexToDelete) => {
    setPropertyImageUrls((prevUrls) =>
      prevUrls.filter((_, i) => i !== indexToDelete)
    );
  };
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setThumbnailImage({
        file,
        preview: URL.createObjectURL(file),
      });
      UploadImage(file, "thumbnail");
    }
  };

  const handleGardenFloorChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      UploadImage(files[0], "gardenFloor");
    }
  };

  const handleMainFloorChange = (e) => {
    const { files } = e.target;
    if (files && files[0]) {
      let url = URL.createObjectURL(files[0]);
      UploadImage(files[0], "mainFloor");
    }
  };

  const UploadImage = async (file, type = "property") => {
  //   dispatch(setLoading(true));
  // const [isLoading, setIsLoading] = useState(false);
    setIsLoading(true)
    // const formData = new FormData();
    // formData.append("file", file);

      // Ensure file is under 5MB, try compressing if needed
  const safeFile = await compressToUnder5MB(file);

  const formData = new FormData();
  formData.append("file", safeFile);

  try {
      const response = await api.post(API_ENDPOINTS.IMAGE_UPLOAD, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      const uploadedUrl = response.data.data;
      console.log("uploadedUrl", response);
      if (type === "mainFloor") {
        setMainFloor(uploadedUrl);
      } else if (type === "gardenFloor") {
        setGardenFloor(uploadedUrl);
      } else if (type === "thumbnail") {
        setThumbnailUrl(uploadedUrl);
      } else if (type === "floor") {
        setFloorImages([]);
        setFloorImageUrls((prev) => [...prev, uploadedUrl]);
      } else {
        setPropertyImages([]);
        setPropertyImageUrls((prev) => [...prev, uploadedUrl]);
      }
    } catch (error) {
      console.error("Upload error:", error);
    } finally {
      // dispatch(setLoading(false));
       setIsLoading(false)
    }
  };
  const handleAddNew = () => {
    setErrors({});
    setEditingItem(null);
    setNewTitle("");
    setNewDescription("");
    setFeaturesDesc("");
    setPrice("");
    setAddress("");
    setCity("");
    setStateVal("");
    setZipCode("");
    setPropertyType("apartment");
    setStatus("available");
    setBedrooms("");
    setBathrooms("");
    setAreaSqft("");
    setLeaseTerm("");
    setAvailableFrom(new Date().toISOString().slice(0, 10));
    setBuildstyleId("");
    setCommunityId("");
    setIsActive(true);
    setBuildstyleIds([]);
    setCommunityIds([]);
    setAminityIds([]);
    setFeatureIds([]);
    setThumbnailImage(null);
    setThumbnailUrl("");
    setPropertyImages([]);
    setPropertyImageUrls([]);
    setOpen(true);

    setMainFloor("");
    setGardenFloor("");
    setParking("");
    setVideoUrl("");

    setFloorImages([]);
    setFloorImageUrls([]);
  };

  const handleDeleteThumbnail = () => {
    setThumbnailImage(null);
    setThumbnailUrl("");
  };

  const handleFloorImagesChange = (e) => {
    const files = Array.from(e.target.files);
    const previews = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setFloorImages((prev) => [...prev, ...previews]);
    files.forEach((file) => UploadImage(file, "floor"));
  };

  const handleDeleteExistingFloorImage = (indexToDelete) => {
    setFloorImageUrls((prevUrls) =>
      prevUrls.filter((_, i) => i !== indexToDelete)
    );
  };

  const handleDeleteNewFloorImage = (indexToDelete) => {
    setFloorImages((prev) => {
      URL.revokeObjectURL(prev[indexToDelete].preview);
      return prev.filter((_, i) => i !== indexToDelete);
    });
  };
  const handleDeletePropertyImage = (index) => {
    setPropertyImages((prev) => {
      URL.revokeObjectURL(prev[index].url); // clean up URL object
      return prev.filter((_, i) => i !== index);
    });
    setPropertyImageUrls((prev) => prev.filter((_, i) => i !== index));
  };

  const handleEdit = (item) => {
    setErrors({});
    console.log(" item.communityname_ids", item.communityname_ids);
    setEditingItem(item);
    setNewTitle(item.title || "");
    setNewDescription(item.description || "");
    setPrice(item.price || "");
    setAddress(item.address || "");
    setCity(item.city_id || "");
    setStateVal(item.state_id || "");
    setZipCode(item.zip_code || "");
    setPropertyType(item.property_type || "apartment");
    setStatus(item.status || "available");
    setLeaseTerm(item.lease_term?.toString() || "");
    setBedrooms(item.bedrooms?.toString() || "");
    setBathrooms(item.bathrooms?.toString() || "");
    setAreaSqft(item.area_sqft?.toString() || "");
    setAvailableFrom(
      item.available_from?.slice(0, 10) || new Date().toISOString().slice(0, 10)
    );
    setIsActive(!!item.isactive);

    // Optional: handle single IDs if present
    setBuildstyleId(item.buildstyle_id?.toString() || "");
    setCommunityId(item.communityname_ids);

    setFeaturesDesc(item.featuresproperty || "");
    // Handle multi-select arrays from comma-separated strings
    setBuildstyleIds(
      item.stylename_ids
        ? item.stylename_ids.split(",").map((id) => parseInt(id))
        : []
    );
    setCommunityIds(
      item.communityname_ids
        ? item.communityname_ids.split(",").map((id) => parseInt(id))
        : []
    );
    setAminityIds(
      item.amenity_ids
        ? item.amenity_ids.split(",").map((id) => parseInt(id))
        : []
    );
    setFeatureIds(
      item.feature_ids
        ? item.feature_ids.split(",").map((id) => parseInt(id))
        : []
    );

    // Optional: If editing also allows showing image previews

    setGardenFloor(item.gardenFloor);
    setMainFloor(item.mainFloor);
    setThumbnailUrl(item.image_small || "");

    setPropertyImageUrls(item.image_paths);
    setFloorImageUrls(item.gardenFloors);
    setParking(item.parking);
    setVideoUrl(item.videoUrl);

    // setPropertyImageUrls(item.image_path ? item.image_path.split(",") : []);

    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    // handleAddNew(); // reset all fields
  };
  const validateFields = () => {
    const newErrors = {};
    // Title
    if (!newTitle || !newTitle.trim()) newErrors.newTitle = "Title is required";
    // Price
    if (!price || isNaN(price) || Number(price) <= 0)
      newErrors.price = "Valid price is required";
    // Description
    if (!newDescription || !newDescription.trim())
      newErrors.newDescription = "Description is required";
    // Features Description (optional, but if required, uncomment below)
    if (!featuresDesc || !featuresDesc.trim())
      newErrors.featuresDesc = "Features description is required";
    // State
    if (!stateVal) newErrors.stateVal = "State is required";
    // City
    if (!city) newErrors.city = "City is required";
    // Address
    if (!address || !address.trim()) newErrors.address = "Address is required";
    // Zip Code
    if (!zipCode || !zipCode.trim()) newErrors.zipCode = "Zip Code is required";
    // Property Type
    if (!propertyType) newErrors.propertyType = "Property type is required";
    // Status
    if (!status) newErrors.status = "Status is required";
    // Parking
    if (!parking) newErrors.parking = "Parking is required";
    // Video Url
     
    // if (!videoUrl || !videoUrl.trim())
    //   newErrors.videoUrl = "Video Url is required";
    // Bedrooms
    if (bedrooms === "" || isNaN(bedrooms) || Number(bedrooms) < 0)
      newErrors.bedrooms = "Valid bedrooms is required";
    // Bathrooms
    if (bathrooms === "" || isNaN(bathrooms) || Number(bathrooms) < 0)
      newErrors.bathrooms = "Valid bathrooms is required";
    // Area Sqft
    if (areaSqft === "" || isNaN(areaSqft) || Number(areaSqft) < 0)
      newErrors.areaSqft = "Valid area (sqft) is required";
    // Lease Term
    if (leaseTerm === "" || isNaN(leaseTerm) || Number(leaseTerm) < 0)
      newErrors.leaseTerm = "Valid lease term is required";
    // Community
    if (!communityId) newErrors.communityId = "Community is required";
    // Build Style
    if (!buildstyleIds || buildstyleIds.length === 0)
      newErrors.buildstyleIds = "At least one build style is required";
    // Features (multi-select)
    if (!featuresIds || featuresIds.length === 0)
      newErrors.featuresIds = "At least one feature is required";
    // Community (dropdown)
    if (!communityId) newErrors.communityId = "Community is required";
    // Build Style (dropdown)
    if (!buildstyleIds || buildstyleIds.length === 0)
      newErrors.buildstyleIds = "At least one build style is required";
    // Features (dropdown)
    if (!featuresIds || featuresIds.length === 0)
      newErrors.featuresIds = "At least one feature is required";
    // Parking
    if (!parking) newErrors.parking = "Parking is required";
    // Available From
    if (!availableFrom)
      newErrors.availableFrom = "Available from date is required";
    // Thumbnail Image
    if (!thumbnailImage && !thumbnailUrl)
      newErrors.thumbnail = "Thumbnail image is required";
    // Property Images
    if (propertyImages.length === 0 && propertyImageUrls.length === 0)
      newErrors.propertyImages = "At least one property image is required";
    // Floor Plan Images (optional, but if required, uncomment below)
    // if (floorImages.length === 0 && floorImageUrls.length === 0)
    //   newErrors.floorImages = "At least one floor plan image is required";
    return newErrors;
  };
  const handleSubmit = async () => {
    const fieldErrors = validateFields();
    // console.log("fieldErrors", fieldErrors);
    setErrors(fieldErrors);
    if (Object.keys(fieldErrors).length > 0) {
      // Optionally, show a snackbar error here
      // showErrorSnackbar("Please fill all required fields.");
      return;
    }
    const payload = {
      title: newTitle,
      description: newDescription,
      price,
      address,
      city,
      state: stateVal,
      zip_code: zipCode,
      property_type: propertyType,
      status,
      bedrooms: bedrooms || 0, // fallback to 0 if empty
      bathrooms: bathrooms || 0, // fallback to 0 if empty
      area_sqft: areaSqft || 0, // fallback to 0 if empty
      lease_term: leaseTerm || 0, // fallback to 0 if empty
      available_from: availableFrom,
      user_id: IsLoginData.idUser,
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      buildstyle_id: buildstyleId,
      community_id: communityId,
      isactive: isActive ? 1 : 0,

      gardenFloor: gardenFloor,
      mainFloor: mainFloor,
      videoUrl: videoUrl,
      parking: parking,

      // Array fields
      amenity_name_list: aminityIds,
      feature_name_list: featuresIds,
      stylename_list: buildstyleIds,
      communityname_list: [communityId], //communityIds,

      // Image paths
      image_small: thumbnailUrl || "", // Small image URL
      image_path_list: propertyImageUrls, // Array of property image URLs
      featuresproperty: featuresDesc,
      gardenFloor_path_list: floorImageUrls,
    };
    console.log("Payload", payload);
    try {
      dispatch(setLoading(true));
      let response;
      if (editingItem) {
        payload.property_id = editingItem.property_id;
        response = await api.post(API_ENDPOINTS.UPDATE_PROPRTY, payload);
      } else {
        response = await api.post(API_ENDPOINTS.CREATE_PROPERTY, payload);
      }
      console.log("PropertyRes", response);
      const { status, message } = response.data;
      dispatch(setLoading(false));
      if (status === SUCCESS) {
        showSuccessSnackbar(
          message ||
            (editingItem
              ? `Updated ${tableName} successfully`
              : `Created ${tableName} successfully`)
        );
        handleClose();
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Submit ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const handleOnStateChange = async (e) => {
    setStateVal(e.target.value);
    try {
      dispatch(setLoading(true));
      const response = await api.get(
        `${API_ENDPOINTS.GET_CITY}/${e.target.value}`
      );

      dispatch(setLoading(false));

      const cityRes = transDropdownData(
        "city_id",
        "city",
        response?.data?.data || []
      );
      setCities(cityRes);
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Get ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const handleDelete = (item) => {
    setConfirmDialog({ open: true, data: item });
  };
  const performDelete = async (item) => {
    try {
      dispatch(setLoading(true));
      // console.log("Delete Req::", `${API_ENDPOINTS.DELETE_PROPERTY}${item.property_id}`);
      const response = await api.delete(
        `${API_ENDPOINTS.DELETE_PROPERTY}${item.property_id}`
      );
      const { status, message } = response.data;
      dispatch(setLoading(false));
      // console.log("Delete Response::", response);
      if (status === SUCCESS) {
        showSuccessSnackbar(message || "Property deleted successfully");
        getTableData();
      } else {
        showErrorSnackbar(message || API_FAIL_MESSAGE);
      }
    } catch (error) {
      dispatch(setLoading(false));
      console.error(`Delete ${tableName} failed:`, error);
      showErrorSnackbar(API_FAIL_MESSAGE);
    }
  };
  const { columns, rows } = authorsTableData(
    tableData,
    handleEdit,
    handleDelete
  );

  const handleDeleteNewPropertyImage = (indexToDelete) => {
    setPropertyImages((prevImages) =>
      prevImages.filter((_, i) => i !== indexToDelete)
    );
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
                display="flex"
                justifyContent="space-between"
                alignItems="center"
              >
                <MDTypography variant="h6" color="white">
                  {tableName}
                </MDTypography>
                <Button
                  variant="contained"
                  color="white"
                  startIcon={<Icon>add</Icon>}
                  onClick={handleAddNew}
                >
                  Add New
                </Button>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  // showTotalEntries={false}
                  // noEndBorder
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      {/* <Footer /> */}

      {/* Add/Edit Dialog */}
      <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
          <Loader loading={isLoading} />
        <DialogTitle>
          {editingItem ? `Edit ${tableName}` : `Add New ${tableName}`}
        </DialogTitle>
        <DialogContent dividers>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Title"
                margin="normal"
                value={newTitle}
                onChange={(e) => setNewTitle(e.target.value)}
                error={!!errors?.newTitle}
                helperText={errors?.newTitle}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Price"
                type="number"
                margin="normal"
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                error={!!errors?.price}
                helperText={errors?.price}
              />
            </Grid>
          </Grid>
          <TextField
            fullWidth
            label="Description"
            margin="normal"
            value={newDescription}
            multiline
            minRows={4} // Adjust the number of visible rows as needed
            onChange={(e) => setNewDescription(e.target.value)}
            error={!!errors?.newDescription}
            helperText={errors?.newDescription}
          />
          <TextField
            fullWidth
            label="Features"
            margin="normal"
            value={featuresDesc}
            multiline
            minRows={4} // Adjust the number of visible rows as needed
            onChange={(e) => setFeaturesDesc(e.target.value)}
            error={!!errors?.featuresDesc}
            helperText={errors?.featuresDesc}
          />
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="State"
                margin="normal"
                value={stateVal}
                onChange={handleOnStateChange}
                InputProps={{ style: { height: "40px" } }}
                error={!!errors?.stateVal}
                helperText={errors?.stateVal}
              >
                {states.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="City"
                margin="normal"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                InputProps={{ style: { height: "40px" } }}
                error={!!errors?.city}
                helperText={errors?.city}
              >
                {cities.map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          <Grid container spacing={2}>
            <Grid item xs={12} md={9}>
              <TextField
                fullWidth
                label="Address"
                margin="normal"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
                error={!!errors?.address}
                helperText={errors?.address}
              />
            </Grid>

            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Zip Code"
                margin="normal"
                value={zipCode}
                onChange={(e) => setZipCode(e.target.value)}
                error={!!errors?.zipCode}
                helperText={errors?.zipCode}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Property Type"
                margin="normal"
                value={propertyType}
                onChange={(e) => setPropertyType(e.target.value)}
                InputProps={{ style: { height: "40px" } }}
                error={!!errors?.propertyType}
                helperText={errors?.propertyType}
              >
                <MenuItem value="apartment">Apartment</MenuItem>
                <MenuItem value="house">House</MenuItem>
                <MenuItem value="condo">Condo</MenuItem>
                <MenuItem value="townhouse">Townhouse</MenuItem>
                <MenuItem value="studio">Studio</MenuItem>
              </TextField>
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Status"
                margin="normal"
                value={status}
                onChange={(e) => setStatus(e.target.value)}
                InputProps={{ style: { height: "40px" } }}
                error={!!errors?.status}
                helperText={errors?.status}
              >
                <MenuItem value="available">Available</MenuItem>
                <MenuItem value="pending">Pending</MenuItem>
                <MenuItem value="sold">Sold</MenuItem>
              </TextField>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Bedrooms"
                type="number"
                margin="normal"
                value={bedrooms}
                onChange={(e) => setBedrooms(Number(e.target.value))}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", min: 0 }}
                error={!!errors?.bedrooms}
                helperText={errors?.bedrooms}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Bathrooms"
                type="number"
                margin="normal"
                value={bathrooms}
                onChange={(e) => setBathrooms(Number(e.target.value))}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", min: 0 }}
                error={!!errors?.bathrooms}
                helperText={errors?.bathrooms}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Area (sqft)"
                type="number"
                margin="normal"
                value={areaSqft}
                onChange={(e) => setAreaSqft(Number(e.target.value))}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", min: 0 }}
                error={!!errors?.areaSqft}
                helperText={errors?.areaSqft}
              />
            </Grid>

            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Lease Term (months)"
                type="number"
                margin="normal"
                value={leaseTerm}
                onChange={(e) => setLeaseTerm(Number(e.target.value))}
                inputProps={{ inputMode: "numeric", pattern: "[0-9]*", min: 0 }}
                error={!!errors?.leaseTerm}
                helperText={errors?.leaseTerm}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              {/* <FormControl fullWidth margin="normal">
                <InputLabel>Community</InputLabel>
                <Select
                  multiple
                  value={communityIds}
                  onChange={(e) =>
                    setCommunityIds(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(selected) => (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {selected.map((value) => {
                        const style = communities.find((s) => s.id === value);
                        return (
                          <Chip key={value} label={style?.name || value} />
                        );
                      })}
                    </div>
                  )}
                  inputProps={{
                    "aria-label": "Build Style",
                  }}
                  sx={{
                    minHeight: "40px", // Ensure a minimum height for consistent dropdown height
                    padding: "10px", // Adjust padding for better spacing
                  }}
                >
                  {communities.map((style) => (
                    <MenuItem key={style.id} value={style.id}>
                      {style.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}

              <FormControl
                fullWidth
                margin="normal"
                error={!!errors?.communityId}
              >
                <InputLabel>Community</InputLabel>
                <Select
                  value={communityId}
                  onChange={(e) => setCommunityId(e.target.value)}
                  inputProps={{
                    "aria-label": "Community",
                  }}
                  sx={{
                    minHeight: "40px",
                    padding: "10px",
                  }}
                >
                  {communities.map((style) => (
                    <MenuItem key={style.id} value={style.id}>
                      {style.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors?.communityId && (
                  <Typography color="error" variant="caption">
                    {errors?.communityId}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              {/* <FormControl fullWidth margin="normal">
                <InputLabel>Aminity</InputLabel>
                <Select
                  multiple
                  value={aminityIds}
                  onChange={(e) =>
                    setAminityIds(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(selected) => (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {selected.map((value) => {
                        const style = aminities.find((s) => s.id === value);
                        return <Chip key={value} label={style?.name || value} />;
                      })}
                    </div>
                  )}
                  inputProps={{
                    "aria-label": "Build Style",
                  }}
                  sx={{
                    minHeight: "40px", // Ensure a minimum height for consistent dropdown height
                    padding: "10px", // Adjust padding for better spacing
                  }}
                >
                  {aminities.map((style) => (
                    <MenuItem key={style.id} value={style.id}>
                      {style.name}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl> */}
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                margin="normal"
                error={!!errors?.buildstyleIds}
              >
                <InputLabel>Build Style</InputLabel>
                <Select
                  multiple
                  value={buildstyleIds}
                  onChange={(e) =>
                    setBuildstyleIds(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(selected) => (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {selected.map((value) => {
                        const style = buildStyles.find((s) => s.id === value);
                        return (
                          <Chip key={value} label={style?.name || value} />
                        );
                      })}
                    </div>
                  )}
                  inputProps={{
                    "aria-label": "Build Style",
                  }}
                  sx={{
                    minHeight: "40px",
                    padding: "10px",
                  }}
                >
                  {buildStyles.map((style) => (
                    <MenuItem key={style.id} value={style.id}>
                      {style.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors?.buildstyleIds && (
                  <Typography color="error" variant="caption">
                    {errors?.buildstyleIds}
                  </Typography>
                )}
              </FormControl>
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControl
                fullWidth
                margin="normal"
                error={!!errors?.featuresIds}
              >
                <InputLabel>Features</InputLabel>
                <Select
                  multiple
                  value={featuresIds}
                  onChange={(e) =>
                    setFeatureIds(
                      typeof e.target.value === "string"
                        ? e.target.value.split(",")
                        : e.target.value
                    )
                  }
                  renderValue={(selected) => (
                    <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
                      {selected.map((value) => {
                        const style = features.find((s) => s.id === value);
                        return (
                          <Chip key={value} label={style?.name || value} />
                        );
                      })}
                    </div>
                  )}
                  inputProps={{
                    "aria-label": "Features",
                  }}
                  sx={{
                    minHeight: "40px",
                    padding: "10px",
                  }}
                >
                  {features.map((style) => (
                    <MenuItem key={style.id} value={style.id}>
                      {style.name}
                    </MenuItem>
                  ))}
                </Select>
                {errors?.featuresIds && (
                  <Typography color="error" variant="caption">
                    {errors?.featuresIds}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                select
                fullWidth
                label="Parking"
                margin="normal"
                value={parking}
                onChange={(e) => setParking(e.target.value)}
                InputProps={{ style: { height: "40px" } }}
                error={!!errors?.parking}
                helperText={errors?.parking}
              >
                <MenuItem value="1 Car Garage">1 Car Garage</MenuItem>
                <MenuItem value="1 Parking Space">1 Parking Space</MenuItem>
                <MenuItem value="2 Car Garage">2 Car Garage</MenuItem>
                <MenuItem value="2 Parking Space">2 Parking Space</MenuItem>
                <MenuItem value="3 Car Garage">3 Car Garage</MenuItem>
                <MenuItem value="No Parking">No Parking</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Video Url"
                margin="normal"
                value={videoUrl}
                onChange={(e) => setVideoUrl(e.target.value)}
                error={!!errors?.videoUrl}
                helperText={errors?.videoUrl}
              />
            </Grid>
          </Grid>

          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <TextField
                fullWidth
                label="Available From"
                type="date"
                margin="normal"
                InputLabelProps={{ shrink: true }}
                value={availableFrom}
                onChange={(e) => setAvailableFrom(e.target.value)}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <FormControlLabel
                style={{
                  marginTop: "20px",
                }}
                control={
                  <Switch
                    checked={isActive}
                    onChange={(e) => setIsActive(e.target.checked)}
                  />
                }
                label="Active"
              />
            </Grid>
          </Grid>

          {/* <Box marginTop={2}>
            <InputLabel>Garden Floor Image</InputLabel>
            <input
              accept="image/*,application/pdf"
              type="file"
              onChange={handleGardenFloorChange}
              style={{ marginTop: "8px" }}
            />

            {gardenFloor && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={`${BASE_IMAGE_URL}${gardenFloor}`}
                  alt="Garden Floor Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setGardenFloor("");
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box> */}

          {/* <Box marginTop={2}>
            <InputLabel>Main Floor Image</InputLabel>
            <input
              accept="image/*,application/pdf"
              type="file"
              onChange={handleMainFloorChange}
              style={{ marginTop: "8px" }}
            />

            {mainFloor && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={`${BASE_IMAGE_URL}${gardenFloor}`}
                  alt="Thumbnail Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={() => {
                    setMainFloor("");
                  }}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box> */}

          <Box marginTop={2}>
            <InputLabel>Thumbnail Image</InputLabel>
            <input
              accept="image/*"
              type="file"
              onChange={handleThumbnailChange}
              style={{ marginTop: "8px" }}
            />
            {errors?.thumbnail && (
              <Typography color="error" variant="caption">
                {errors?.thumbnail}
              </Typography>
            )}
            {(thumbnailImage || thumbnailUrl) && (
              <Box display="flex" alignItems="center" mt={2} gap={1}>
                <img
                  src={
                    thumbnailImage?.preview ||
                    (thumbnailUrl.startsWith("http")
                      ? thumbnailUrl
                      : `${BASE_IMAGE_URL}${thumbnailUrl}`)
                  }
                  alt="Thumbnail Preview"
                  width={100}
                  height={100}
                  style={{ objectFit: "cover", borderRadius: 4 }}
                />
                <IconButton
                  color="error"
                  onClick={handleDeleteThumbnail}
                  size="small"
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              </Box>
            )}
          </Box>
          <Box marginTop={2}>
            <InputLabel>Property Images</InputLabel>
            <input
              accept="image/*"
              type="file"
              multiple
              onChange={handlePropertyImagesChange}
              style={{ marginTop: "8px" }}
            />
            {errors?.propertyImages && (
              <Typography color="error" variant="caption">
                {errors?.propertyImages}
              </Typography>
            )}
            {(propertyImages.length > 0 || propertyImageUrls.length > 0) && (
              <Box display="flex" flexWrap="wrap" gap={2} mt={2}>
                {/* Existing images from API */}
                {propertyImageUrls.map((url, index) => (
                  <Box
                    key={`existing-${index}`}
                    position="relative"
                    width={100}
                    height={100}
                  >
                    <img
                      src={`${BASE_IMAGE_URL}${url}`}
                      alt={`existing-${index}`}
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", borderRadius: 4 }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteExistingPropertyImage(index)}
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "white",
                        boxShadow: 1,
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
                {/* New uploads */}
                {propertyImages.map((img, index) => (
                  <Box
                    key={`new-${index}`}
                    position="relative"
                    width={100}
                    height={100}
                  >
                    <img
                      src={img.preview}
                      alt={`new-${index}`}
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", borderRadius: 4 }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteNewPropertyImage(index)}
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "white",
                        boxShadow: 1,
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>

          <Box marginTop={2}>
            <InputLabel>Floor Plan Images</InputLabel>
            <input
              accept="image/*"
              type="file"
              multiple
              onChange={handleFloorImagesChange}
              style={{ marginTop: "8px" }}
            />
            {/* {errors.floorImages && (
              <Typography color="error" variant="caption">
                {errors.floorImages}
              </Typography>
            )} */}
            {(floorImages.length > 0 || floorImageUrls.length > 0) && (
              <Box display="flex" flexWrap="wrap" gap={2} mt={2}>
                {/* Existing images from API */}
                {floorImageUrls.map((url, index) => (
                  <Box
                    key={`existing-${index}`}
                    position="relative"
                    width={100}
                    height={100}
                  >
                    <img
                      src={`${BASE_IMAGE_URL}${url}`}
                      alt={`existing-${index}`}
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", borderRadius: 4 }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteExistingFloorImage(index)}
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "white",
                        boxShadow: 1,
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
                {/* New uploads */}
                {floorImages.map((img, index) => (
                  <Box
                    key={`new-${index}`}
                    position="relative"
                    width={100}
                    height={100}
                  >
                    <img
                      src={img.preview}
                      alt={`new-${index}`}
                      width={100}
                      height={100}
                      style={{ objectFit: "cover", borderRadius: 4 }}
                    />
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleDeleteNewFloorImage(index)}
                      sx={{
                        position: "absolute",
                        top: -10,
                        right: -10,
                        backgroundColor: "white",
                        boxShadow: 1,
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Box>
                ))}
              </Box>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button
            style={{ color: "#fff" }}
            variant="contained"
            onClick={handleSubmit}
          >
            {editingItem ? "Update" : "Submit"}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={confirmDialog.open}
        onClose={() => setConfirmDialog({ open: false, data: null })}
        aria-labelledby="delete-confirm-title"
        sx={{
          "& .MuiDialog-paper": {
            borderRadius: "12px",
            padding: "1rem",
            minWidth: "400px",
          },
        }}
      >
        <DialogTitle
          id="delete-confirm-title"
          sx={{ fontWeight: "bold", textAlign: "center" }}
        >
          Delete Property
        </DialogTitle>
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "1rem",
            fontSize: "1rem",
            color: "text.secondary",
          }}
        >
          Are you sure you want to delete this property?
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", paddingBottom: "1rem" }}>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              performDelete(confirmDialog.data);
              setConfirmDialog({ open: false, data: null });
            }}
          >
            Yes, Delete
          </Button>
          <Button
            variant="contained"
            color="inherit"
            onClick={() => setConfirmDialog({ open: false, data: null })}
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </DashboardLayout>
  );
}

export default Property;
